import React, { createContext, useRef } from 'react';
import WrappedToast from './WrappedToast.component';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
	const toastRef = useRef(null);

	const showToast = message => {
		toastRef.current.show(message);
	};

	return (
		<ToastContext.Provider value={{ showToast }}>
			<WrappedToast ref={toastRef} />
			{children}
		</ToastContext.Provider>
	);
};

export default ToastContext;
